import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const createRule = (data: unknown) => {
  return axios({
    method: "POST",
    url: "/lead-assignment",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getRules = (params: any) => {
  return axios({
    method: "GET",
    url: "/lead-assignment",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchPartnersByRule = (params: any) => {
  return axios({
    method: "GET",
    url: "/tenant",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteRule = (ruleId: number ) => {
  return axios({
    method: "DELETE",
    url: `/lead-assignment/${ruleId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getRuleById = (
  ruleId: number | undefined,
  includeMatchedPartners: boolean
) => {
  return axios.get(`/lead-assignment/${ruleId}`, {
    params: {
      includeMatchedPartners,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editRule = (ruleId: number | undefined,data:any) => {
  return axios({
    method: "PUT",
    url: `/lead-assignment/${ruleId}`,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export const fetchPartnersList = (params: any) => {
  return axios({
    method: "GET",
    url: "/tenant",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const runTheRule = (ruleId: number | undefined) => {
  return axios({
    method: "POST",
    url: `/lead-assignment/run-job/${ruleId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export const getLeadAssignmentHistory = (ruleId: number, params: any) => {
  return axios.get(`/lead-assignment/${ruleId}/assignedLeads`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};